var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm._l(_vm.cashes, function (cash) {
    return [_c('noti-item', _vm._b({
      key: cash._id
    }, 'noti-item', {
      cash: cash
    }, false))];
  })], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }